var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-view',{attrs:{"UserRegister":_vm.UserRegister,"GetVerCode":_vm.GetVerCode,"CheckMobileIsRegisted":_vm.CheckMobileIsRegisted}})}
var staticRenderFns = []

export { render, staticRenderFns }